import { render, staticRenderFns } from "./Pr.vue?vue&type=template&id=b351143e&scoped=true"
import script from "./Pr.vue?vue&type=script&lang=js"
export * from "./Pr.vue?vue&type=script&lang=js"
import style0 from "./Pr.vue?vue&type=style&index=0&id=b351143e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b351143e",
  null
  
)

export default component.exports